import { P2GBox, P2GText, P2GChip } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';
import { ExtraBase } from '~/lib/api/smartsend/types';
import { TranslationNamespaces } from '~/lib/constants';
import { DeliveredDutyPaidExtra, ExtrasDescription } from '../../ExtrasHelper';

export const ItemExtrasTooltipContent = ({
  extra,
  shouldShowPricing,
  selected
}: {
  shouldShowPricing?: boolean;
  selected: boolean;
  extra: ExtraBase & { Available: boolean; TranslatedName: string; Price: number; Included?: boolean };
}) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <>
      <P2GBox
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'nowrap',
          mb: 1
        }}
      >
        <P2GText>
          <strong>{extra.TranslatedName}</strong>
        </P2GText>
        {extra.Included ? (
          <P2GChip label={t('EXTRA_INCLUDED', { defaultValue: 'Included' })} size="small" color="primary" />
        ) : selected ? (
          <P2GChip label={t('EXTRA_SELECTED', { defaultValue: 'Selected' })} size="small" color="success" />
        ) : extra.Available ? null : (
          <P2GChip label={t('EXTRA_UNAVAILABLE', { defaultValue: 'Unavailable' })} size="small" />
        )}
      </P2GBox>
      {shouldShowPricing && (
        <P2GText component="p">
          <strong>
            {extra.Price === 0 ? t('EXTRA_FREE', { defaultValue: 'Free' }) : toDisplayCurrency(null, extra.Price)}
          </strong>
        </P2GText>
      )}
      <P2GText component="p" variant="body2">
        <ExtrasDescription Id={extra.Id} Name={extra.Name} />
      </P2GText>
      {extra.Available &&
        !selected &&
        (extra.Id === DeliveredDutyPaidExtra ? (
          <P2GText component="p" variant="body2">
            {t('EXTRA_ADD_DDP_TOOLTIP', 'Click to view duty options for your item.')}
          </P2GText>
        ) : (
          <P2GText component="p" variant="body2">
            {t('EXTRA_ADD_DEFAULT_TOOLTIP', 'Click to add this extra to your item.')}
          </P2GText>
        ))}
    </>
  );
};
